import { getColor, grey960, transparent } from '../../constants/colors'
import { UniNeueHeavy } from '../../constants/fonts'
import { TvGridLayoutModel } from '../../types/flo-experience'
import PointerBackButton from '../NavigationPointers/PointerBackButton'
import SpeechComp from '../speechComp/speechComp'
import TvGridContainer from '../TvGridContainer/TvGridContainer'

const GRID_WIDTH = 1648
const TOP_SAFE_PADDING = 80
const TITLE_HEIGHT = 108
export const TITLE_SAFE_MARGIN = 80
export const DEFAULT_HEADER_HEIGHT = TITLE_HEIGHT + TOP_SAFE_PADDING + TITLE_SAFE_MARGIN

export default class TvGridLayout extends SpeechComp {
  private _data: TvGridLayoutModel
  private _headerHeight: number = DEFAULT_HEADER_HEIGHT

  static _template() {
    return {
      w: GRID_WIDTH,
      color: transparent,
      flex: {
        direction: 'column',
      },

      Header: {
        visible: false,
        zIndex: 2,
        flex: {
          direction: 'row',
          justifyContent: 'space-between',
        },

        Gradient: {
          flexItem: false,
          flex: {
            direction: 'column',
          },
          w: GRID_WIDTH + 16,
          x: -8,
          h: DEFAULT_HEADER_HEIGHT,

          GradientTop: {
            rect: true,
            h: TOP_SAFE_PADDING + TITLE_HEIGHT,
            color: getColor(grey960),
          },
          GradientBottom: {
            rect: true,
            h: TITLE_SAFE_MARGIN / 2,
            colorTop: getColor(grey960),
            colorBottom: transparent,
          },
        },
        Title: {
          text: {
            text: '',
            fontSize: 64,
            fontFace: UniNeueHeavy,
            lineHeight: 56,
          },
        },
        Buttons: {
          flex: { direction: 'row' },
        },
      },
      PointerBackButton: {
        type: PointerBackButton,
      },

      TvGridContainer: {
        type: TvGridContainer,
        flex: {
          direction: 'column',
        },
      },
    }
  }

  set data(v: TvGridLayoutModel) {
    this._data = v

    if (v.title) {
      this.showHeader()
      this.tvGridContainer.pageText = v.title.text
      this.title.patch({ text: { text: v.title.text } })
    }

    if (v.buttons?.length) {
      this.showHeader()
    }

    if (!this.header.visible) {
      this.tvGridContainer.patch({ y: TOP_SAFE_PADDING })
    }

    this.tvGridContainer.hasHeader = this.header.visible
    this.tvGridContainer.data = v.container
  }

  set headerHeight(height: number) {
    this._headerHeight = height
  }

  get headerHeight() {
    return this._headerHeight
  }

  get data() {
    return this._data
  }

  get header() {
    return this.tag('Header')
  }

  get gradientTop() {
    return this.tag('GradientTop')
  }

  get title() {
    return this.tag('Title')
  }

  get buttons() {
    return this.tag('Buttons')
  }

  get pointerBackButton() {
    return this.tag('PointerBackButton') as PointerBackButton
  }

  get tvGridContainer() {
    return this.tag('TvGridContainer') as TvGridContainer
  }

  _getFocused() {
    return this.tvGridContainer
  }

  showHeader() {
    this.header.patch({
      h: this._headerHeight,
      visible: true,
      flex: {
        alignItems: 'center',
      },
    })

    this.tvGridContainer.headerHeight = this._headerHeight
  }
}
